import { render, staticRenderFns } from "./ProductMedia.vue?vue&type=template&id=09c0f621&name=product-media&"
import script from "./ProductMedia.vue?vue&type=script&lang=js&"
export * from "./ProductMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports